import { LocaleBundle } from "../types";

const ar: LocaleBundle = {
  "ui": {
    "nav": {
      "features": "الميزات",
      "pricing": "التسعير",
      "integrations": "التكاملات",
      "industries": "الصناعات",
      "apiDocs": "التوثيق",
      "about": "حول",
      "customers": "العملاء",
      "contact": "اتصل بنا",
      "login": "تسجيل الدخول",
      "getFreeCRM": "احصل على FreeCRM",
      "openMenu": "فتح القائمة",
      "language": "اللغة"
    },
    "hero": {
      "badge": "نظام إدارة علاقات العملاء متعدد القنوات: البريد الإلكتروني، الصوت والرسائل النصية القصيرة",
      "titleStart": "نظام إدارة علاقات العملاء المصمم لـ ",
      "titleHighlight": "فرق المبيعات متعددة القنوات",
      "subtitle": "تواصل مع كل عميل أينما كان — مع التسويق عبر البريد الإلكتروني، الصوت، والرسائل النصية القصيرة المدمجة في منصة واحدة. بدون إضافات، وبدون تكلفة باهظة للشركات الكبيرة.",
      "cta": "ابدأ مجانًا — لا يلزم وجود بطاقة",
      "pills": [
        "التسويق عبر البريد الإلكتروني",
        "الصوت والاتصال",
        "الرسائل النصية القصيرة ثنائية الاتجاه"
      ],
      "iosApp": "تطبيق iOS",
      "androidApp": "تطبيق Android",
      "heroAlt": "لوحة تحكم FreeCRM تُظهر مسار الصفقات وإدارة جهات الاتصال"
    },
    "logos": {
      "trustedBy": "موثوق به من قبل أكثر من 25,000 فريق متنامي"
    },
    "features": {
      "eyebrow": "الميزات",
      "title": "نظام إدارة علاقات عملاء واحد. كل قناة يستخدمها عملاؤك.",
      "subtitle": "التسويق عبر البريد الإلكتروني، الصوت، والرسائل النصية القصيرة في منصة واحدة — ليتمكن فريقك من الوصول إلى العملاء المحتملين بالطريقة التي يفضلونها.",
      "items": [
        {
          "title": "التسويق عبر البريد الإلكتروني",
          "desc": "صمم الحملات، أرسل رسائل جماعية، واعمل على رعاية العملاء المحتملين بالتسلسلات — كل ذلك من نفس سجل جهة الاتصال."
        },
        {
          "title": "الصوت والاتصال",
          "desc": "النقر للاتصال، تسجيل المكالمات، والتسجيل مدمج مباشرة. المكالمات الواردة مشمولة مع بريد صوتي قابل للبرمجة — اربط رقمك وابدأ المحادثات على الفور."
        },
        {
          "title": "الرسائل النصية القصيرة ثنائية الاتجاه",
          "desc": "راسل العملاء المحتملين والعملاء من نفس صندوق الوارد. يتضمن القوالب، الإرسال المجدول، وسجل المحادثات الكامل."
        },
        {
          "title": "تسلسلات متعددة القنوات",
          "desc": "اجمع بين البريد الإلكتروني، الرسائل النصية القصيرة، والمكالمات في إيقاع واحد. تصل إلى كل عميل محتمل على القناة التي يستجيب لها بالفعل."
        },
        {
          "title": "تحليلات موحدة",
          "desc": "تتبع الفتحات، النقرات، الردود، الاتصالات، والتحويلات عبر كل قناة في لوحة تحكم واحدة."
        },
        {
          "title": "الأتمتة",
          "desc": "سجل العملاء المحتملين تلقائيًا في الحملات، وقم بتدويرهم بين الممثلين، وشغل المتابعات بناءً على أي إشارة."
        },
        {
          "title": "جدولة الاجتماعات",
          "desc": "شارك روابط حجز عامة بأنواع اجتماعات متعددة. تُبقي مزامنة التقويم أوقات التوفر محدّثة، ويتم إنشاء روابط المؤتمرات المرئية تلقائيًا لكل اجتماع."
        },
        {
          "title": "التكاملات",
          "desc": "اربط Google وMicrosoft 365 وDocuSign وQuickBooks وZapier ومؤتمرات الفيديو مع Zoom وGoogle Meet وZoho Meeting لإبقاء بياناتك متزامنة وأتمتة سير العمل في الأدوات التي تستخدمها بالفعل."
        },
        {
          "title": "CRM بمساعدة الذكاء الاصطناعي",
          "desc": "دع الذكاء الاصطناعي يصيغ ردود البريد الإلكتروني ويقترح الخطوات التالية ويُلخّص المحادثات ويُبقي كل صفقة قيد التقدم — لكي يقضي فريقك وقتًا أقل في الكتابة وأكثر في البيع."
        }
      ]
    },
    "testimonials": {
      "eyebrow": "العملاء",
      "title": "موثوق به من قبل فرق المبيعات متعددة القنوات",
      "items": [
        {
          "quote": "لقد استبدلنا ثلاث أدوات — التسويق عبر البريد الإلكتروني، المسجل، ونظام إدارة علاقات العملاء — بـ FreeCRM. يدير فريقنا الآن حملات عبر البريد الإلكتروني، الرسائل النصية القصيرة، والمكالمات من مكان واحد.",
          "name": "مايا تشين",
          "role": "نائب رئيس المبيعات، B2B SaaS"
        },
        {
          "quote": "تسلسلات القنوات المتعددة غيرت كل شيء. الجمع بين البريد الإلكتروني والرسائل النصية القصيرة والمكالمة في إيقاع واحد ضاعف معدل الردود لدينا دون زيادة في عدد الموظفين.",
          "name": "دانيال أوكافور",
          "role": "مدير المبيعات، حلول Apex"
        },
        {
          "quote": "انتقلنا من HubSpot إلى FreeCRM وحصلنا أخيرًا على التسويق عبر البريد الإلكتروني والصوت والرسائل النصية القصيرة في منصة واحدة — بدون أي تكاليف تكامل.",
          "name": "بريا رامان",
          "role": "المدير التنفيذي للعمليات، Brightline"
        }
      ]
    },
    "pricing": {
      "eyebrow": "التسعير",
      "title": "تسعير برمجيات إدارة علاقات العملاء",
      "subtitle": "أرقام الهواتف الأمريكية 1.15 دولار فقط شهريًا · 0.01 دولار للدقيقة · 0.01 دولار للرسالة النصية القصيرة",
      "mostPopular": "الأكثر شيوعًا",
      "perUserMo": "/مستخدم/شهريًا",
      "tiers": [
        {
          "name": "مجاني",
          "price": "$0",
          "blurb": "مجاني للأبد مع البريد الإلكتروني والصوت والرسائل النصية القصيرة المدمجة.",
          "cta": "اشترك مجانًا"
        },
        {
          "name": "احترافي",
          "price": "$10",
          "blurb": "قوة CRM كاملة لفرق المبيعات المتنامية.",
          "cta": "اشترك"
        },
        {
          "name": "مؤسسي",
          "price": "$25",
          "blurb": "ميزات متقدمة للفرق ذات الحجم الكبير.",
          "cta": "اشترك"
        }
      ],
      "sharedFeatures": [
        "تخزين غير محدود",
        "جهات الاتصال والشركات",
        "الصفقات والمهام",
        "الحالات والمكالمات",
        "التقويم والمستندات",
        "التقارير",
        "تطبيقات iOS و Android",
        "الحملات والنماذج",
        "البريد الإلكتروني",
        "الوصول إلى API",
        "مزامنة Google",
        "QuickBooks",
        "الرسائل النصية القصيرة",
        "الاتصال الصوتي",
        "بطاقة الائتمان"
      ]
    },
    "faq": {
      "eyebrow": "الأسئلة الشائعة",
      "title": "إجابات على الأسئلة",
      "items": [
        {
          "q": "هل FreeCRM مجاني حقًا للبريد الإلكتروني والصوت والرسائل النصية القصيرة؟",
          "a": "نعم — تتضمن الخطة المجانية التسويق عبر البريد الإلكتروني، النقر للاتصال، تسجيل المكالمات، و500 رسالة نصية قصيرة شهريًا بدون تكلفة. تفتح الخطط المدفوعة حدود إرسال أكبر، وأتمتة متقدمة، وتسجيل المكالمات، ورسائل نصية غير محدودة."
        },
        {
          "q": "بماذا يختلف FreeCRM عن HubSpot؟",
          "a": "على عكس HubSpot، كل قناة أصلية — التسويق عبر البريد الإلكتروني، الصوت، والرسائل النصية القصيرة كلها متضمنة، وليست تباع كإضافات منفصلة أو تكاملات مكلفة."
        },
        {
          "q": "هل يمكنني تشغيل حملات وتسلسلات البريد الإلكتروني؟",
          "a": "نعم. صمم رسائل جماعية، حملات بالتنقيط، وتسلسلات متعددة الخطوات تجمع بين البريد الإلكتروني والرسائل النصية القصيرة والمكالمات — مع تتبع كامل للفتحات والنقرات والردود."
        },
        {
          "q": "كيف تعمل خدمة الهاتف في FreeCRM؟",
          "a": "تحدث المكالمات مباشرة في متصفحك — لا حاجة إلى هاتف أو برنامج اتصال منفصل. أجرِ مكالمات صادرة بنقرة واحدة، واستقبل مكالمات واردة على رقم FreeCRM الخاص بك، ووجّهها إلى الممثل المناسب. البريد الصوتي القابل للبرمجة مع التحيات المخصصة والنسخ التلقائي يضمن عدم فقدان أي مكالمة فائتة."
        },
        {
          "q": "هل تدعمون الرسائل النصية القصيرة ثنائية الاتجاه؟",
          "a": "نعم. أرسل واستقبل الرسائل النصية القصيرة من نفس صندوق الوارد الخاص ببريدك الإلكتروني، مع القوالب، الإرسال المجدول، وسجل المحادثات الكامل لكل جهة اتصال."
        }
      ]
    },
    "cta": {
      "title1": "البريد الإلكتروني والصوت والرسائل النصية القصيرة في نظام CRM واحد.",
      "title2": "تواصل مع العملاء عبر كل قناة.",
      "subtitle": "انضم إلى أكثر من 25,000 فريق يستخدمون FreeCRM للتسويق عبر البريد الإلكتروني والصوت والرسائل النصية القصيرة — كل ذلك في منصة واحدة مجانية ومتعددة القنوات.",
      "button": "ابدأ مجانًا"
    },
    "footer": {
      "tagline": "نظام إدارة علاقات العملاء المجاني الذي ينمو مع عملك.",
      "copyright": "جميع الحقوق محفوظة.",
      "tagBuiltFor": "مصمم للفرق التي تستحق أفضل من HubSpot.",
      "cols": {
        "product": "المنتج",
        "company": "الشركة",
        "resources": "الموارد",
        "legal": "قانوني"
      },
      "links": {
        "features": "الميزات",
        "pricing": "التسعير",
        "integrations": "التكاملات",
        "industries": "الصناعات",
        "changelog": "سجل التغييرات",
        "about": "حول",
        "customers": "العملاء",
        "careers": "الوظائف",
        "contact": "اتصل بنا",
        "blog": "المدونة",
        "helpCenter": "مركز المساعدة",
        "apiDocs": "التوثيق",
        "community": "المجتمع",
        "privacy": "الخصوصية",
        "terms": "الشروط",
        "security": "الأمان",
        "dpa": "ملحق معالجة البيانات"
      }
    },
    "contentPage": {
      "readyToStart": "هل أنت مستعد للبدء؟",
      "joinThousands": "انضم إلى الآلاف من الفرق التي تستخدم FreeCRM لدعم التسويق عبر البريد الإلكتروني والصوت والرسائل النصية القصيرة وخط أعمال المبيعات.",
      "defaultCta": "ابدأ مجانًا — لا يلزم وجود بطاقة",
      "learnMore": "اعرف المزيد ←"
    },
    "languageNames": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português",
      "it": "Italiano", "de": "Deutsch", "ar": "العربية", "ru": "الروسية"
    }
  },
  "featurePages": {
    "calling": {
      "title": "الاتصال المدمج",
      "eyebrow": "الميزة",
      "description": "النقر للاتصال، المكالمات الواردة مع بريد صوتي قابل للبرمجة، مكالمات المتصفح، أرقام افتراضية، تسجيل، والمتصل الفعال — كلها مدمجة في FreeCRM.",
      "intro": "حلول CRM لمركز الاتصال من FreeCRM تقوم بأتمتة المكالمات الواردة والصادرة في 90 دولة. المكالمات الواردة مشمولة مع بريد صوتي قابل للبرمجة — احصل على رقم افتراضي أو استخدم رقم هاتفك المحمول، وابدأ الاتصال من أي سجل جهة اتصال.",
      "sections": [
        {
          "heading": "النقر للاتصال من أي مكان",
          "body": "اكتشف لماذا نحن نظام CRM المجاني رقم 1 لأتمتة قوة المبيعات، التسويق، وخدمة العملاء — مع ميزة النقر للاتصال لإجراء مكالمات المتصفح لأي رقم هاتف، من أي جهة اتصال، صفقة، أو سجل شركة."
        },
        {
          "heading": "التسجيل، الجدولة ومكالمات المجموعات",
          "body": "سجل المكالمات للتدريب والامتثال، جدولة المتابعات، استضافة مكالمات جماعية، وإرسال الرسائل النصية القصيرة — كل ذلك من داخل نظام CRM بدون أدوات إضافية."
        },
        {
          "heading": "المكالمات الواردة والبريد الصوتي القابل للبرمجة",
          "body": "كل رقم FreeCRM يتلقى المكالمات الواردة والصادرة — بدون رسوم إضافية. وجّه المكالمات إلى الممثل المناسب، حدد ساعات العمل، واضبط بريدًا صوتيًا قابلًا للبرمجة مع تحيات مخصصة ونسخ تلقائي حتى لا تُفقد أي رسالة."
        },
        {
          "heading": "المتصل الفعال وكتابة نصوص المكالمات",
          "body": "زد من الفعالية مع العملاء الحاليين والمحتملين. تضمن كتابة نصوص المكالمات القوية والأتمتة نتائج مبيعات موثوقة، مما يساعدك على زيادة أرباحك."
        },
        {
          "heading": "الحملات والمتابعات",
          "body": "أنشئ حملات مكالمات ورسائل نصية قصيرة، وقم بأتمتة المكالمات والرسائل النصية القصيرة، ونظم وجدول متابعاتك حتى لا يفوتك شيء."
        }
      ]
    },
    "contacts": {
      "title": "إدارة جهات الاتصال والعملاء المحتملين",
      "eyebrow": "الميزة",
      "description": "جهات اتصال غير محدودة، حقول مخصصة، واستيراد قوي من Outlook، Salesforce، HubSpot، أو Zoho.",
      "intro": "جهات الاتصال هي عملاؤك المحتملون، العملاء المتوقعون، والعملاء — البائعون، الشركاء، المانحون. في FreeCRM، جهات اتصالك ثمينة ونحن نتعامل معها بهذه الطريقة.",
      "sections": [
        {
          "heading": "خصص كل شيء",
          "body": "أضف أكبر عدد ممكن من الحقول المخصصة التي تحتاجها. كل عمل يحتاج إلى نظام CRM مخصص — مع FreeCRM يمكنك تخصيص أوراق الاتصال، النماذج، وكل جزء من النظام."
        },
        {
          "heading": "تتبع كل تفاعل",
          "body": "تتبع وإدارة العلاقات، المكالمات، والاجتماعات. اربط المستندات، ملاحظات الاجتماعات والمكالمات، وغيرها من المعلومات الهامة بالأشخاص الذين تعمل لديهم ومعهم."
        },
        {
          "heading": "B2B، B2C والمزيد",
          "body": "جهات الاتصال هي أفراد يمكن أن ينتموا إلى شركات أو منظمات أخرى. نحن ندعم B2B، B2C، ونماذج أعمال أكثر تعقيدًا."
        },
        {
          "heading": "استيراد من أي مكان",
          "body": "استورد قوائم جهات الاتصال من أي ملف جدول بيانات، Outlook، Salesforce، HubSpot، Zoho، أو أي برنامج آخر لإدارة جهات الاتصال."
        }
      ]
    },
    "companies": {
      "title": "الشركات والحسابات",
      "eyebrow": "الميزة",
      "description": "تتبع المنظمات والبائعين والشركاء باستخدام حقول مخصصة وقوائم وسجل نشاط مشترك.",
      "intro": "توفر قائمة الشركات في FreeCRM تتبعًا قويًا ومرنًا للتنظيم لأي كيان — B2B، B2C، غير ربحي، أو حكومي — مع حقول قابلة للتخصيص بالكامل.",
      "sections": [
        {
          "heading": "التنظيم والمشاركة",
          "body": "قم بالتنظيم حسب الفئة، الحالة، الأولوية، أو المرشحات المخصصة. استورد وصدر القوائم فورًا، أنشئ قوائم غير محدودة، وشارك المعلومات التنظيمية عبر فريقك."
        },
        {
          "heading": "جميع الأنشطة في مكان واحد",
          "body": "يتم تتبع والإبلاغ عن مكالمات المبيعات، تذاكر المشكلات، وأنشطة العملاء. يتم تنظيم حملات البريد الإلكتروني وتتبع أتمتة المكالمات حسب الشركة."
        },
        {
          "heading": "لماذا الشركات؟",
          "body": "من خلال تتبع الشركات التي تتعامل معها، يمكن لفرقك تنسيق حملات مبيعات أكثر فعالية وتحديد ومشاركة الفرص عبر مؤسستك."
        }
      ]
    },
    "deals": {
      "title": "مسار الصفقات",
      "eyebrow": "الميزة",
      "description": "مسار مبيعات مرئي، تتبع المراحل، التوقعات، والتقارير — مصمم لفرق المبيعات الخارجية.",
      "intro": "الصفقات هي سبب وجودك هنا. تتيح لك مجموعة ميزات FreeCRM Deal إدارة وتتبع العملاء المحتملين، وتطبيق منهجية مبيعات سليمة للارتقاء بعملك إلى المستوى التالي.",
      "sections": [
        {
          "heading": "تتبع المراحل",
          "body": "يتم تتبع الصفقات من خلال الحالة — عرض سعر، تقدير، أمر شراء، فاتورة، عمولة — حتى تعرف دائمًا أين تقف كل فرصة."
        },
        {
          "heading": "التقارير والتوقعات",
          "body": "يوفر مسار العمل جداول وتقارير ومخططات توضح أداء فريق المبيعات والحملات الخاصة بك. قم بتقدير النجاح بمرور الوقت وحدد فرصًا جديدة داخل العملاء الجدد أو الحاليين."
        },
        {
          "heading": "التعاون الجماعي",
          "body": "تتبع الصفقات يضفي التماسك على الأشخاص الذين يدعمون مبيعاتك. يمكن للخدمات والدعم التعاون طوال الدورة لإظهار وتحقيق نجاح الفريق."
        }
      ]
    },
    "tasks": {
      "title": "إدارة المهام",
      "eyebrow": "الميزة",
      "description": "تحديد الأولويات، تعيين، وتتبع المهام مع سير العمل والحالة — عبر الصفقات، جهات الاتصال، والحالات.",
      "intro": "تتيح لك أنظمة تتبع المهام والمشكلات والمبيعات رؤية كاملة للوقت الذي تقضيه أنت وفريقك في كل صفقة أو مشكلة.",
      "sections": [
        {
          "heading": "أنشئ مهمة!",
          "body": "قم بترتيب المهام حسب الأولوية، أنشئ أنواع مهام مخصصة لعملك، عيّن المهام لأعضاء الفريق أو الموظفين، امنحهم سير عمل وحالة، ووزع عبء العمل عبر فريقك."
        },
        {
          "heading": "مفوض أفضل",
          "body": "لأنك تستطيع تعيين المهام، فإنك تصبح على الفور مفوضًا أفضل دون فقدان الرؤية لجودة الخدمة التي يقدمها فريقك."
        }
      ]
    },
    "cases": {
      "title": "إدارة الحالات",
      "eyebrow": "الميزة",
      "description": "فتح التذاكر، توجيه المشكلات، تخصيص الحالات والأولويات، وحل كل حالة عميل.",
      "intro": "توفر أنظمة تتبع الحالات والمشكلات رؤية بنسبة 100% عبر المشكلات التي تقدمها للعملاء والبائعين والشركاء.",
      "sections": [
        {
          "heading": "مكتب مساعدة افتراضي",
          "body": "ابدأ حالة جديدة وافتح تذكرة في مكتب المساعدة الافتراضي الخاص بك. اربط الحالات طويلة الأمد بالمشكلات الجارية التي يمكن حلها وإغلاقها بسرعة."
        },
        {
          "heading": "تخصيص لفريقك",
          "body": "خصص مشكلات الدعم باستخدام حقول مخصصة، وقم بتعيين المشكلات لعضو فريق واحد أو أكثر، وتتبع كل حالة حتى لا يفوت أي مشكلة عملاء."
        },
        {
          "heading": "ربط كل شيء",
          "body": "اربط الحالات بالشركات، جهات الاتصال، المكالمات، الأحداث، أو المستندات. أضف الملاحظات مع تقدم المشكلة واحتفظ بجميع المعلومات في حالة واحدة مريحة."
        }
      ]
    },
    "campaigns": {
      "title": "أتمتة التسويق",
      "eyebrow": "الميزة",
      "description": "حملات البريد الإلكتروني والرسائل النصية القصيرة، التجزئة، والأتمتة المدمجة في نظام إدارة علاقات العملاء الخاص بك.",
      "intro": "أنشئ قوائم بريدية بناءً على البيانات الديموغرافية، التفضيلات، والتفاعلات. أنشئ ونفذ حملات بريد إلكتروني مخصصة في أربع خطوات بسيطة.",
      "sections": [
        {
          "heading": "مخصصة على نطاق واسع",
          "body": "لا يقتصر برنامج التسويق عبر البريد الإلكتروني في نظام إدارة علاقات العملاء على إرسال رسائل بريد إلكتروني جماعية — بل ينشئ تسلسلات مخصصة، ويدير قوائم مستهدفة، ويتابع تلقائيًا."
        },
        {
          "heading": "قوالب جاهزة للجوال",
          "body": "قوالب بريد إلكتروني سهلة التخصيص ومتجاوبة عبر جميع الأجهزة، بما في ذلك الهواتف المحمولة والأجهزة اللوحية والمزيد."
        },
        {
          "heading": "الرسائل النصية + البريد الإلكتروني معًا",
          "body": "اجمع بين تسلسلات البريد الإلكتروني والرسائل النصية القصيرة. تفاعل مع عملائك كما لم يحدث من قبل واحتفظ بكل شيء في مكان واحد."
        }
      ]
    },
    "calendar": {
      "title": "التقويم الجماعي",
      "eyebrow": "الميزة",
      "description": "تقويم فريق مشترك مع تذكيرات بالبريد الإلكتروني والرسائل النصية القصيرة، متكامل بالكامل مع جهات الاتصال والصفقات والمهام.",
      "intro": "تقويم FreeCRM الجماعي هو وسيلة رائعة لإدارة وعرض جدولك الزمني، الأنشطة اليومية والأسبوعية والشهرية لفريقك، اجتماعات العملاء، والمكالمات.",
      "sections": [
        {
          "heading": "لا تفوت أي حدث",
          "body": "أرسل إشعارات عبر البريد الإلكتروني والرسائل النصية القصيرة حتى لا يكون لدى أحد أي عذر لعدم حضور حدث مرة أخرى."
        },
        {
          "heading": "متصل بكل شيء",
          "body": "تتبع الأحداث القادمة، قم بتعيين تذكيرات، أنشئ مهام، أدخل ملاحظات، أرفق ملفات، واربط إدخالات التقويم بجهة اتصال واحدة أو أكثر. عيّن المهام لواحد أو أكثر من الزملاء."
        },
        {
          "heading": "التصفية حسب الفريق أو جهة الاتصال",
          "body": "عرض الأحداث لكامل قاعدة البيانات، لجهة اتصال واحدة، لنفسك، لزميل، أو لعدة أعضاء فريق. لا يفصلك عن التاريخ أو معلومات الاتصال سوى نقرة واحدة."
        }
      ]
    },
    "documents": {
      "title": "إدارة المستندات",
      "eyebrow": "الميزة",
      "description": "تخزين مستندات غير محدود، وصول عبر الجوال، ومرفقات ملفات لكل سجل.",
      "intro": "شارك المستندات الهامة مع فريقك ووفّر وصولاً فوريًا إلى جميع ملفاتك الإلكترونية. حمّل ملفًا واحدًا أو دليلًا كاملاً بنقرة واحدة.",
      "sections": [
        {
          "heading": "تخزين غير محدود",
          "body": "تتضمن خدمتنا المجانية تخزينًا غير محدود لجميع مستندات فريقك الهامة. يمكن لكل عضو أن يكون لديه مخزن مستندات خاص به ويربط الملفات بأي سجل."
        },
        {
          "heading": "الجوال أولاً",
          "body": "يمكنك الوصول إلى المستندات من تطبيقات iOS و Android الخاصة بنا — افتح نظام إدارة علاقات العملاء عبر الجوال، اسحب مستندًا، وأرسل رسائل SMS ورسائل بريد إلكتروني إلى العملاء المحتملين على الفور."
        },
        {
          "heading": "تجميع الأصول",
          "body": "مكان آمن وموثوق به لتجميع أصول مستنداتك الإلكترونية. يمكن لفريقك الوصول إلى العقود، ومواد المبيعات والتسويق، والنماذج الموحدة، والمزيد من أي مكان في العالم."
        }
      ]
    },
    "email": {
      "title": "أتمتة البريد الإلكتروني",
      "eyebrow": "الميزة",
      "description": "تسلسلات بريد إلكتروني مخصصة، قوائم مجزأة، واستهداف يعتمد على CRM.",
      "intro": "أنشئ قوائم بريدية بناءً على البيانات الديموغرافية، التفضيلات، والتفاعلات للرسائل المستهدفة. وفر الوقت وزد الإنتاجية بنسبة 74% باستخدام أدوات البريد الإلكتروني المناسبة.",
      "sections": [
        {
          "heading": "أربع خطوات بسيطة",
          "body": "أنشئ ونفذ حملات بريد إلكتروني مخصصة في أربع خطوات بسيطة باستخدام برنامج CRM للتسويق عبر البريد الإلكتروني."
        },
        {
          "heading": "أكثر من مجرد رسائل جماعية",
          "body": "يساعد التسويق عبر البريد الإلكتروني في CRM الفرق في أكثر من مجرد متابعة العملاء المحتملين، إرسال رسائل بريد إلكتروني جماعية، أو إنشاء تسلسلات مخصصة."
        },
        {
          "heading": "قوالب متجاوبة",
          "body": "قوالب سهلة التخصيص ومتجاوبة عبر جميع الأجهزة — الهواتف والأجهزة اللوحية وأجهزة الكمبيوتر المكتبية."
        }
      ]
    },
    "forms": {
      "title": "النماذج والاستبيانات",
      "eyebrow": "الميزة",
      "description": "نماذج معالج متعددة الصفحات، نصوص مكالمات، واستبيانات يتم إدخالها مباشرة إلى CRM.",
      "intro": "النماذج هي استبيانات سؤال وجواب — ويمكن أن تكون أيضًا نصوص مكالمات يكملها موظفو المبيعات أو الدعم مع العملاء المحتملين على الخط.",
      "sections": [
        {
          "heading": "نماذج المعالج",
          "body": "إنشاء النماذج والاستبيانات سهل باستخدام أداة إنشاء النماذج لدينا، مما يسمح بإنشاء نماذج معالج متعددة الصفحات سهلة المتابعة والإكمال. بمجرد الانتهاء، ستُمنح رابطًا عامًا لتوزيعه."
        },
        {
          "heading": "ملاحظات العملاء ونصوص داخلية",
          "body": "استخدم النماذج لملاحظات العملاء، واستبيانات الموظفين، ونصوص المكالمات. أنشئ استبيانات مخصصة للمبيعات، التسويق، ورضا العملاء."
        },
        {
          "heading": "التقارير والتصدير",
          "body": "يتم إدخال نتائج نماذج الويب والاستبيانات في نظام تقارير، ويتم تقديمها كجداول. قم بالتصدير إلى Excel أو CSV لتحليلها أو لاستيرادها للتسويق."
        }
      ]
    }
  },
  "industryPages": {
    "callcenter": {
      "title": "FreeCRM لمراكز الاتصال",
      "eyebrow": "الصناعة",
      "description": "CRM لمركز الاتصال مزود بقرص داخلي وتسجيل وكتابة نصوص ورسائل نصية قصيرة SMS في 90 دولة.",
      "intro": "أتمتة المكالمات الواردة والصادرة في 90 دولة حول العالم. احصل على رقم هاتف افتراضي وقم بتفعيل ميزات مركز الاتصال مباشرة.",
      "sections": [
        {
          "heading": "كل مكالماتك، في مكان واحد",
          "body": "النقر للاتصال من المتصفح لأي رقم هاتف. احصل على رقم افتراضي أو استخدم رقم هاتفك المحمول — FreeCRM يفعل كل ذلك."
        },
        {
          "heading": "التسجيل والجدولة",
          "body": "قم بإجراء تسجيلات للمكالمات، وجدول المكالمات والمكالمات الجماعية، وأرسل رسائل SMS من أي جهاز. ميزات متقدمة لأتمتة مركز الاتصال."
        },
        {
          "heading": "كتابة النصوص والأتمتة",
          "body": "تضمن ميزات كتابة النصوص القوية والأتمتة نتائج مبيعات موثوقة. قم بإنشاء نصوص يتم تعيينها وجدولتها لأعضاء الفريق؛ تتبع كل مكالمة ونتائجها في نظامنا الغني بالميزات."
        },
        {
          "heading": "الحملات والمتابعة",
          "body": "أنشئ حملات مكالمات ورسائل نصية قصيرة، وقم بأتمتتها، ونظم المتابعات حتى لا يفوت فريقك أي نقطة اتصال."
        }
      ]
    },
    "insurance": {
      "title": "FreeCRM للتأمين",
      "eyebrow": "الصناعة",
      "description": "سحابة CRM للتأمين للوكلاء، المصدّرين، والخدمات لتتبع العملاء، السياسات، والمطالبات.",
      "intro": "يساعد نظام CRM الخاص بالقطاع التأميني الوكلاء، المصدّرين، والخدمات على البيع للمستهلكين والشركات وتتبع جميع التفاعلات في السحابة.",
      "sections": [
        {
          "heading": "مصمم للوكلاء والمكتتبين",
          "body": "سواء كنت وكيلاً، مكتتبًا، مزود خدمة، أو أي اختصاصي تأمين آخر، يمكننا مساعدتك في تلبية احتياجاتك من CRM."
        },
        {
          "heading": "السياسات، المطالبات والعملاء",
          "body": "قم بأتمتة تتبع العملاء الهامين، السياسات، المطالبات، والمزيد باستخدام قوالب التأمين الجاهزة التي تعمل لقطاع B2C و B2B."
        },
        {
          "heading": "مصمم للاحتفاظ بالعملاء",
          "body": "يعد نظام إدارة علاقات العملاء (CRM) أمرًا بالغ الأهمية في مجال التأمين بسبب المنتجات المعقدة، والحاجة إلى التواصل المستمر، وأهمية الاحتفاظ بالعملاء."
        }
      ]
    },
    "realestate": {
      "title": "FreeCRM للعقارات",
      "eyebrow": "الصناعة",
      "description": "إدارة العملاء المحتملين والعقارات لمحترفي العقارات السكنية والتجارية.",
      "intro": "يُستخدم FreeCRM في جميع مجالات العقارات من قبل كل فئة من المحترفين — سواء في العقارات السكنية أو التجارية، الشراء، البيع، السمسرة، أو الإدارة.",
      "sections": [
        {
          "heading": "إدارة العملاء المحتملين والممتلكات",
          "body": "تبسيط إدارة العملاء المحتملين وإدارة الممتلكات في العقارات السكنية والتجارية. يحب وكلاء العقارات نظام CRM الخاص بنا — وكذلك السماسرة ومديرو الممتلكات."
        },
        {
          "heading": "قائمة العقارات كصفقات",
          "body": "استخدم قسم 'الصفقات' لسرد العقارات — عادةً حسب العنوان (مثل '100 Main Street'). أضف العديد من العملاء المحتملين إلى عقار واحد واستخدم لوحة المبيعات أو المسار لتتبع مسارات التحويل."
        },
        {
          "heading": "جمعيات الملاك والأصول المعقدة",
          "body": "يستخدم مديرو العقارات في السكنية والتجارية والشقق متعددة الأسر والشقق السكنية الشاهقة وجمعيات الملاك FreeCRM لإدارة كل جانب من جوانب العمليات."
        }
      ]
    },
    "dental": {
      "title": "FreeCRM لطب الأسنان",
      "eyebrow": "الصناعة",
      "description": "برنامج CRM جاهز لـ HIPAA لأطباء الأسنان، جراحي الفم، ومجتمع طب الأسنان المتخصص.",
      "intro": "نحن ندعم صناعة طب الأسنان بأحدث أنظمة إدارة علاقات العملاء لأطباء الأسنان، وجراحي الفم، وجميع أفراد المجتمع الطبي المتخصص — ونقدم شهادة BAA للامتثال لـ HIPAA.",
      "sections": [
        {
          "heading": "موضع ثقة الآلاف من الممارسات",
          "body": "مع الآلاف من العملاء في مجال طب الأسنان، يتعامل FreeCRM مع متطلبات الامتثال لطب الأسنان، جراحة الفم، زراعة الأسنان، والصناعات المجاورة التي تتعامل مع معلومات المرضى."
        },
        {
          "heading": "أمن البيانات",
          "body": "أمن البيانات هو كل ما يدور حوله FreeCRM. يتم استضافة الخوادم على AWS — متوافقة مع HIPAA — ونحن نقدم شهادات BAA للممارسات التي تحتاجها."
        },
        {
          "heading": "دمج مجموعتك",
          "body": "ابدأ بسرعة وتكامل مع أنظمة إدارة الممارسات والتصوير الرئيسية المستخدمة في جميع أنحاء مجال طب الأسنان."
        }
      ]
    },
    "hipaa": {
      "title": "FreeCRM متوافق مع HIPAA",
      "eyebrow": "الامتثال",
      "description": "FreeCRM متوافق مع HIPAA لأكثر من عقد — شهادات BAA متاحة مع خطة Enterprise.",
      "intro": "إدارة معلومات الرعاية الصحية للمرضى أمر صعب. أطلقت FreeCRM HIPAACRM.com في عام 2014 — أول نظام CRM متوافق مع HIPAA في العالم — ولا تزال رائدة في مجال الأمان والمساءلة.",
      "sections": [
        {
          "heading": "هل تحتاج إلى BAA؟",
          "body": "إذا كنت بحاجة إلى شهادة ملحق شريك تجاري (BAA) لضمان الامتثال لـ HIPAA، يمكننا المساعدة. إصدار Enterprise الخاص بنا مطلوب، ويدفع سنويًا لكل مقعد مقدمًا (300 دولار/مستخدم/سنة)."
        },
        {
          "heading": "ما وراء الممارسات الطبية",
          "body": "لا يقتصر الأمر على الممارسات الطبية فقط — التجارب السريرية، أخصائيو التغذية، المعالجون، وأي عمل يتعامل مع معلومات الرعاية الصحية يستفيد من دعمنا لـ HIPAA."
        },
        {
          "heading": "أحدث التقنيات الأمنية",
          "body": "12 عامًا من الخبرة في HIPAA، مستضافة على AWS، مع الأمان والمساءلة التي تحتاجها للحصول على معلومات صحية محمية."
        }
      ]
    },
    "insidesales": {
      "title": "FreeCRM للمبيعات الداخلية والمستقلة",
      "eyebrow": "الصناعة",
      "description": "عزز الإنتاجية بأكثر من 30% باستخدام أتمتة CRM بسيطة مصممة لممثلي المبيعات الداخليين والمستقلين.",
      "intro": "يساعد FreeCRM ممثلي المبيعات المستقلين وفرق المبيعات الداخلية على زيادة الإنتاجية باستخدام أدوات ولوحات تحكم بسيطة لأتمتة CRM.",
      "sections": [
        {
          "heading": "زيادة الإنتاجية بأكثر من 30%",
          "body": "يمكن لممثلي المبيعات المستقلين زيادة المبيعات بأكثر من 30% بمجرد تتبع جهات الاتصال والشركات — وتعمل أدوات الأتمتة لدينا على تضخيم هذا التأثير."
        },
        {
          "heading": "تتبع كل تفاعل",
          "body": "سجل كل مكالمة وبريد إلكتروني واجتماع. احتفظ بسجل واضح لما قيل وما يجب أن يحدث بعد ذلك، حدد أولويات المهام وتابع في الوقت المحدد."
        },
        {
          "heading": "مناسب للعاملين لحسابهم الخاص",
          "body": "مصمم لاستقلالية ممثلي المبيعات المستقلين الذين يمثلون شركات متعددة. أدر جدولك الزمني وعلاقات العملاء من أي مكان."
        }
      ]
    },
    "contractor": {
      "title": "FreeCRM للمقاولين والبنائين",
      "eyebrow": "الصناعة",
      "description": "إدارة الصفقات، المقاولين من الباطن، الجدولة، والتنبيهات في الوقت الفعلي للمقاولين العامين والبنائين التجاريين.",
      "intro": "يستخدم المقاولون، البناؤون، المقاولون العامون، وبائعي البناء التجاري FreeCRM بسهولة لإدارة الصفقات والأطراف الثالثة المتعددة مثل المقاولين من الباطن.",
      "sections": [
        {
          "heading": "إدارة العملاء المحتملين",
          "body": "تتبع العملاء المحتملين، راقب التقدم، وحدد الأولويات للجهود. احصل على رؤى حول سلوك العملاء المحتملين لتتمكن من تحديد من يجب متابعته."
        },
        {
          "heading": "التقديرات والمقترحات",
          "body": "أتمتة عملية التقدير وتقديم المقترحات باستخدام قاعدة بيانات مركزية للمقترحات السابقة، والتقديرات، وبيانات التسعير — مما يوفر الوقت ويحسن الدقة."
        },
        {
          "heading": "الجدولة والتنبيهات",
          "body": "عيّن الفرق والأفراد بسرعة مع تنبيهات في الوقت الفعلي عبر البريد الإلكتروني أو الرسائل النصية القصيرة. حافظ على تنسيق المقاولين من الباطن والأطقم."
        }
      ]
    },
    "professional": {
      "title": "FreeCRM للخدمات الاحترافية",
      "eyebrow": "الصناعة",
      "description": " إدارة العملاء، الامتثال، وتقديم الخدمات لشركات الخدمات الاحترافية.",
      "intro": "تستخدم شركات الخدمات الاحترافية FreeCRM لإدارة بيانات العملاء، تتبع التفاعلات، وتقديم خدمة أفضل من أي مكان، على أي جهاز.",
      "sections": [
        {
          "heading": "تحسين رضا العملاء",
          "body": "نظرة كاملة على علاقة العميل — تفاصيل الاتصال، المعاملات السابقة، تفضيلات التواصل — تؤدي إلى رضا العملاء وولائهم بشكل أعلى."
        },
        {
          "heading": "امتثال أسهل",
          "body": "الوفاء بمتطلبات GDPR والمتطلبات المشابهة من خلال موقع مركزي لتخزين ومشاركة وثائق الامتثال، والشفافية في مصادر بيانات العميل."
        },
        {
          "heading": "توسيع الشركة",
          "body": "يجب أن يكون CRM اليوم متاحًا من أي مكان، وعلى أي جهاز، بأي لغة — مع ذكاء اجتماعي وأفضل الممارسات مدمج لمساعدتك على التحرك بشكل أسرع."
        }
      ]
    }
  },
  "integrationPages": {
    "google": {
      "title": "FreeCRM + Google Workspace",
      "eyebrow": "التكامل",
      "description": "مزامنة Gmail، Google Calendar، و Google Contacts مع FreeCRM بنقرة واحدة.",
      "intro": "يتكامل Gmail و Google Workspace بعمق مع FreeCRM. اربط حسابك في Google وقم بمزامنة البريد الإلكتروني، جهات الاتصال، والتقويم.",
      "sections": [
        {
          "heading": "إعداد بنقرة واحدة",
          "body": "من السهل إضافة حسابك في Google — تمامًا مثل أي تطبيق آخر متكامل مع Google، يتم ذلك بتسجيل دخول واحد. يمكنك أيضًا استخدام حسابك في Google لتسجيل الدخول إلى FreeCRM."
        },
        {
          "heading": "مزامنة ما تريد",
          "body": "بمجرد إضافة Google إلى FreeCRM، اختر ما إذا كنت تريد مزامنة الحساب بالكامل أو مجرد استخدام وظيفة البريد الإلكتروني المتكاملة. يتم تضمين التقويم و Google Contacts عند المزامنة."
        },
        {
          "heading": "Workspace يصبح نظام إدارة علاقات العملاء (CRM)",
          "body": "يمكن لأنظمة CRM عالية التكامل تحويل Google Workspace إلى نظام CRM قوي يعمل مع استضافة Google للشركات أو أي حساب Gmail."
        }
      ]
    },
    "quickbooks": {
      "title": "FreeCRM + QuickBooks",
      "eyebrow": "التكامل",
      "description": "تكامل QuickBooks CRM الأعلى تقييمًا — عبر الإنترنت والكمبيوتر المكتبي، مزامنة ثنائية الاتجاه.",
      "intro": "أفضل تكامل لـ QuickBooks — مصنف رقم 1 من قبل QuickBooks ProAdvisors. يسهل CRM لـ QuickBooks Online و Desktop العمليات ويساعدك على زيادة المبيعات.",
      "sections": [
        {
          "heading": "تكامل وثيق",
          "body": "إذا كنت تبحث عن تطبيق CRM متكامل بشكل وثيق مع QuickBooks Online، فإن FreeCRM هو الحل الأمثل."
        },
        {
          "heading": "مركزية بيانات العملاء",
          "body": "يستخدم CRM الذي يتكامل مع QuickBooks تكاملات برامج المحاسبة لتخزين بيانات العملاء ومركزيتها عبر المبيعات والمالية."
        },
        {
          "heading": "عبر الإنترنت + سطح المكتب",
          "body": "يتم دعم كل من QuickBooks Online و QuickBooks Desktop."
        }
      ]
    },
    "zapier": {
      "title": "FreeCRM + Zapier",
      "eyebrow": "التكامل",
      "description": "ربط FreeCRM بأكثر من 6,000 تطبيق على Zapier — أسهل طريقة للأتمتة.",
      "intro": "اربط موصل FreeCRM فورًا بالتطبيقات التي تستخدمها يوميًا. يتكامل FreeCRM مع 6,000 تطبيق آخر على Zapier — أسهل طريقة للأتمتة.",
      "sections": [
        {
          "heading": "أكثر من 6,000 تطبيق",
          "body": "من Slack إلى Stripe إلى Google Sheets، قم بدفع وسحب البيانات من FreeCRM إلى بقية مجموعتك دون كتابة أي رمز."
        },
        {
          "heading": "أتمتة بدون كود",
          "body": "أنشئ Zaps لتسجيل المكالمات، إنشاء جهات الاتصال، مزامنة الصفقات، وتشغيل الحملات كلما حدث شيء في أدواتك الأخرى."
        }
      ]
    },
    "docusign": {
      "title": "FreeCRM + DocuSign",
      "eyebrow": "التكامل",
      "description": "إرسال وتوقيع وتتبع الاتفاقيات مباشرة من نظام CRM الخاص بك مع تكامل DocuSign.",
      "intro": "DocuSign هو المنصة الرائدة عالمياً لتوقيع المستندات. يتيح لك FreeCRM تبسيط العمليات عن طريق ملء المستندات ببيانات CRM وتحديث CRM من حقول DocuSign.",
      "sections": [
        {
          "heading": "التتبع في الوقت الفعلي",
          "body": "اطلب التوقيعات وتتبع حالة الاتفاقية في الوقت الفعلي. وفر الوقت مع سير العمل المخصص الذي يشغل الاتفاقيات بنقرة زر واحدة — وقلل الأخطاء."
        },
        {
          "heading": "تدفق البيانات ثنائي الاتجاه",
          "body": "أتمتة سير العمل بالكامل، وإنشاء العقود وإرسالها، وأرشفة المستندات المكتملة. تحديث الأنظمة ببيانات المستندات أو ملء المستندات من CRM — يعمل في كلا الاتجاهين."
        }
      ]
    },
    "whatsapp": {
      "title": "FreeCRM + WhatsApp",
      "eyebrow": "التكامل",
      "description": "استخدم WhatsApp Business API لإجراء المكالمات والرسائل النصية من داخل FreeCRM.",
      "intro": "يشكل WhatsApp و FreeCRM مزيجًا قويًا — استخدم WhatsApp Business API للاتصال والرسائل النصية، وقم بأتمتة التقاط العملاء المحتملين والاتصالات.",
      "sections": [
        {
          "heading": "اتصال مبسط",
          "body": "إدارة تفاعلات العملاء عبر WhatsApp في مكان مركزي واحد لأوقات استجابة أسرع ورضا أعلى."
        },
        {
          "heading": "تكامل بيانات العملاء",
          "body": "جلب بيانات عملاء WhatsApp إلى FreeCRM وأتمتة المهام المتكررة مثل إعادة توجيه الرسائل، وترتيب أولويات الردود، وإدخال البيانات."
        }
      ]
    },
    "microsoft365": {
      "title": "FreeCRM + Microsoft 365",
      "eyebrow": "تكامل",
      "description": "زامن Outlook والتقويم وجهات الاتصال مع FreeCRM باستخدام Microsoft 365.",
      "intro": "يتكامل Microsoft 365 مع FreeCRM بحيث يمكنك مزامنة بريد Outlook والتقويم وجهات الاتصال في مكان واحد.",
      "sections": [
        {
          "heading": "تسجيل دخول Microsoft بنقرة واحدة",
          "body": "اربط حساب Microsoft 365 واستخدمه لتسجيل الدخول إلى FreeCRM، تمامًا مثل أي تطبيق آخر مدمج مع Microsoft."
        },
        {
          "heading": "البريد والتقويم وجهات الاتصال",
          "body": "اختر ما تريد مزامنته — تبقى محادثات البريد الإلكتروني وأحداث التقويم وجهات اتصال Outlook محدّثة بين FreeCRM وMicrosoft 365."
        },
        {
          "heading": "جاهز للفرق",
          "body": "يعمل مع Outlook الشخصي وMicrosoft 365 Business والمستأجرين Enterprise حتى يظل فريقك بالكامل متزامنًا."
        }
      ]
    },
    "video-conferencing": {
      "title": "FreeCRM + مؤتمرات الفيديو",
      "eyebrow": "تكامل",
      "description": "إنشاء روابط Zoom وGoogle Meet وZoho Meeting تلقائيًا لكل اجتماع محدد.",
      "intro": "ينشئ جدولة FreeCRM روابط مؤتمرات مرئية تلقائيًا لكل اجتماع. اربط Zoom وGoogle Meet وZoho Meeting ليتمكن العملاء المحتملون والعملاء من الانضمام بنقرة واحدة.",
      "sections": [
        {
          "heading": "روابط اجتماعات تلقائية",
          "body": "عندما يحجز شخص ما اجتماعًا عبر رابط FreeCRM، يتم إنشاء رابط Zoom أو Google Meet أو Zoho Meeting وإدراجه تلقائيًا في دعوة التقويم."
        },
        {
          "heading": "مزودون متعددون",
          "body": "استخدم المزود الذي يدفعه فريقك بالفعل — Zoom أو Google Meet أو Zoho Meeting — أو دع الحضور يختارون."
        },
        {
          "heading": "تقويم موحد",
          "body": "تبقى تفاصيل الاجتماع والروابط والتسجيلات مرفقة بسجل جهة الاتصال أو الصفقة أو الحالة بحيث يكون كل شيء في مكان واحد."
        }
      ]
    },
    "aws": {
      "title": "FreeCRM على AWS",
      "eyebrow": "البنية التحتية",
      "description": "توفر بستة تسعات، مهندسون على مدار الساعة طوال أيام الأسبوع، وأمان بيانات على مستوى اتحادي على Amazon AWS.",
      "intro": "يعمل FreeCRM على Amazon AWS بهدف تحقيق توفر ستة تسعات (99.9999%). المهندسون على أهبة الاستعداد على مدار الساعة طوال أيام الأسبوع.",
      "sections": [
        {
          "heading": "مرافق على مستوى اتحادي",
          "body": "تفي مرافقنا المادية أو تتجاوز جميع المتطلبات الفدرالية والدولية لأمن البيانات، الزائدة عن الحاجة، استئناف الأعمال، والاستمرارية."
        },
        {
          "heading": "أعلى جودة سحابة",
          "body": "ثق بنا لتقديم أعلى جودة من الخدمات السحابية المتاحة في أي مكان — مشفرة، مراقبة، ومتاحة باستمرار."
        }
      ]
    }
  },
  "footerPages": {
    "features": {
      "title": "كل ما تحتاجه في CRM واحد",
      "eyebrow": "الميزات",
      "description": "تضمين الاتصال، الرسائل القصيرة، الصفقات، جهات الاتصال، المهام، الحالات، الحملات، التقويم، المستندات، التقارير، واجهة برمجة التطبيقات، والتكاملات — مجاناً إلى الأبد.",
      "intro": "يوفر لك FreeCRM جهات الاتصال، الشركات، الصفقات، المهام، الحالات، المكالمات، التقويم، المستندات، التقارير، الحملات، النماذج، البريد الإلكتروني، واجهة برمجة التطبيقات، والتكاملات — كل ذلك في مكان واحد، مجانًا للأبد."
    },
    "pricing": {
      "title": "التسعير",
      "description": "نظام CRM مجاني إلى الأبد. الإصدار الاحترافي بسعر 10 دولارات/للمستخدم/شهريًا. الإصدار المؤسسي بسعر 25 دولارًا/للمستخدم/شهريًا. أرقام الهواتف الأمريكية 1.15 دولار/شهريًا، 0.01 دولار/دقيقة، 0.01 دولار/لرسالة SMS."
    },
    "integrations": {
      "title": "التكاملات والتطبيقات المتصلة",
      "eyebrow": "التكاملات",
      "description": "ربط FreeCRM مع Google، Microsoft 365، QuickBooks، Zapier، DocuSign، WhatsApp، Zoom، Google Meet، Zoho Meeting، وأكثر من 6,000 تطبيق.",
      "intro": "يتصل FreeCRM بالأدوات التي تستخدمها بالفعل — Google Workspace، Microsoft 365، QuickBooks، Zapier، DocuSign، WhatsApp، Zoom، Google Meet، Zoho Meeting، وآلاف أخرى — للحفاظ على مزامنة بياناتك وأتمتة سير عملك."
    },
    "changelog": {
      "title": "ما الجديد في FreeCRM",
      "eyebrow": "سجل التغييرات",
      "description": "التحسينات الأخيرة، والميزات الجديدة، والإصلاحات التي تم شحنها إلى FreeCRM.",
      "intro": "نقوم بشحن التحسينات باستمرار. فيما يلي أبرز النقاط من الإصدارات القليلة الماضية.",
      "sections": [
        {
          "heading": "مايو 2026 — المتصل الفعال 2.0",
          "body": "اتصال محلي أسرع، ترك رسائل صوتية أكثر ذكاءً، واختصارات لتصنيف المكالمات تقلل من العمل بعد المكالمة إلى النصف."
        },
        {
          "heading": "أبريل 2026 — تطبيقات iOS و Android جديدة",
          "body": "تطبيقات جوال جديدة تمامًا مع دعم عدم الاتصال بالإنترنت، إشعارات تلقائية للمكالمات والرسائل النصية القصيرة الواردة، ووصول كامل إلى مسار العمل من هاتفك."
        },
        {
          "heading": "مارس 2026 — مزامنة QuickBooks ثنائية الاتجاه",
          "body": "العملاء، الفواتير، والمدفوعات تتم مزامنتها الآن ثنائياً بين FreeCRM و QuickBooks Online و Desktop."
        },
        {
          "heading": "فبراير 2026 — تدريب على المكالمات",
          "body": "تحكمات الاستماع المباشر، الهمس، والمقاطعة للمديرين، بالإضافة إلى تسجيل المكالمات الذي تم إنشاؤه بواسطة الذكاء الاصطناعي في Enterprise."
        }
      ]
    },
    "about": {
      "title": "حول FreeCRM",
      "eyebrow": "الشركة",
      "description": "منذ عام 2003، قدمت FreeCRM أول نظام CRM مجاني بالكامل في العالم، رائدة في نموذج الأعمال التجاري المجاني لفرق المبيعات والخدمة والتسويق.",
      "intro": "لماذا FreeCRM مجاني؟ لأننا نؤمن بعملك. لقد قدمنا أول نظام CRM مجاني بالكامل في العالم منذ عام 2003 — وقد ساعدنا مئات الآلاف من الشركات على النمو.",
      "sections": [
        {
          "heading": "لماذا مجاني؟",
          "body": "نقدم لك CRM مجانيًا كاستثمار فيك وفي عملك. نعلم أننا سنساعدك على تحقيق النجاح، وأنه في وقت ما في المستقبل، قد تدفع لنا. مع نمو مبيعاتك، سترغب في المزيد من الميزات — و Pro و Enterprise موجودان عندما تكون جاهزًا."
        },
        {
          "heading": "لقد رُفَعنا نموذج الأعمال المجاني",
          "body": "لقد ابتكرت FreeCRM نموذج الأعمال المجاني: برنامج قوي مجانًا، مع خيار الترقية للرسائل النصية القصيرة، الاتصال الصوتي، QuickBooks، وصول API المتقدم، Zapier، والمزيد."
        },
        {
          "heading": "مبني على AWS",
          "body": "نحن نأخذ أمن البيانات على محمل الجد. يعمل FreeCRM على Amazon AWS بهدف تحقيق توفر ستة تسعات (99.9999%). المهندسون على أهبة الاستعداد على مدار الساعة طوال أيام الأسبوع، وتفي مرافقنا أو تتجاوز المتطلبات الفدرالية والدولية لأمن البيانات، الزائدة عن الحاجة، والاستمرارية."
        },
        {
          "heading": "شامل بالتصميم",
          "body": "نظام CRM القوي هو تطبيق عمل شامل يتعامل مع عمليات الواجهة الخلفية والواجهة الأمامية. FreeCRM قوي — ومجاني — ويغطي المبيعات، الخدمة، التسويق، الاتصال، والعمليات في مكان واحد."
        }
      ]
    },
    "customers": {
      "title": "العملاء يحبون FreeCRM",
      "eyebrow": "العملاء",
      "description": "اطلع على كيفية استخدام فرق المبيعات الخارجية ومراكز الاتصال والشركات الصغيرة والمتوسطة لـ FreeCRM لإجراء 40% المزيد من المكالمات وإغلاق الصفقات بشكل أسرع.",
      "intro": "مئات الآلاف من الفرق — من الشركات الناشئة المكونة من شخصين إلى مراكز الاتصال التي تضم 50 مقعدًا — تدير المبيعات والخدمات على FreeCRM.",
      "sections": [
        {
          "heading": "المبيعات الداخلية — زيادة بنسبة 40% في المكالمات",
          "body": "\"انتقل ممثلو المبيعات لدينا من 80 مكالمة في اليوم إلى أكثر من 110 بمجرد انتقالنا إلى FreeCRM. لقد غير المتصل الآلي وميزة النقر للاتصال داخل عرض جهة الاتصال كل شيء.\" — نائب رئيس المبيعات، B2B SaaS"
        },
        {
          "heading": "مراكز الاتصال — استبدال نظام بقيمة 18 ألف دولار سنويًا",
          "body": "\"لقد استبدلنا أدوات الاتصال، CRM، والرسائل القصيرة لدينا بـ FreeCRM ووفرنا 18 ألف دولار سنويًا — دون فقدان أي ميزة يهتم بها ممثلونا.\" — مدير العمليات، التأمين"
        },
        {
          "heading": "الشركات الصغيرة والمتوسطة — نقل 50 مقعدًا",
          "body": "\"لقد قمنا بتشغيل FreeCRM لـ 50 وكيلًا في غضون أسبوعين. تم تفعيل توفير الأرقام المحلية وتسجيل المكالمات في اليوم الأول.\" — رئيس الإيرادات، خدمات المنازل"
        },
        {
          "heading": "المنظمات غير الربحية — إدارة المانحين",
          "body": "\"يتيح لنا FreeCRM التعامل مع المانحين كجهات اتصال والتبرعات كصفقات. السعر مناسب، وميزات الاتصال هي تغيير جذري.\" — المدير التنفيذي، منظمة غير ربحية"
        }
      ]
    },
    "careers": {
      "title": "وظائف في FreeCRM",
      "eyebrow": "الوظائف",
      "description": "انضم إلى فريق يعمل عن بعد لبناء نظام CRM المجاني الأكثر شعبية في العالم مع ميزة الاتصال المدمج والرسائل النصية القصيرة.",
      "intro": "نحن فريق يعمل عن بعد لبناء نظام CRM المجاني الأكثر شعبية في العالم. إذا كنت تحب البرامج البسيطة، والتكرار السريع، والعملاء الذين يستخدمون ما تبنيه بالفعل، فنحن نود التحدث معك.",
      "sections": [
        {
          "heading": "كيف نعمل",
          "body": "فرق صغيرة، أسلوب عمل غير متزامن أولاً، يعتمد على الكتابة أولاً. نقوم بالإطلاق كل أسبوع. نوظف ذوي الخبرة، ونمنح الثقة للأشخاص لتملك عملهم، وندفع رواتب تنافسية نقدًا وبالأسهم."
        },
        {
          "heading": "وظائف شاغرة",
          "body": ""
        },
        {
          "heading": "كيفية التقديم",
          "body": "أرسل بريدًا إلكترونيًا إلى careers@freecrm.com مع الوظيفة التي تهتم بها، وملاحظة موجزة حول السبب، وروابط لأعمالك. نرد على كل طلب."
        }
      ],
      "roles": [
        "مهندس برمجيات متكامل كبير (React / Node)",
        "مهندس اتصالات (WebRTC, SIP)",
        "مصمم منتجات",
        "نجاح العملاء — مبيعات خارجية",
        "مدير حسابات — الشركات الصغيرة والمتوسطة"
      ]
    },
    "contact": {
      "title": "اتصل بـ FreeCRM",
      "eyebrow": "الاتصال",
      "description": "تحدث إلى المبيعات، احصل على دعم المنتجات، أو تواصل مع فرق الخصوصية والأمان لدينا.",
      "intro": "نحن هنا للمساعدة. تواصل مع الفريق المناسب أدناه — عادة ما نرد في غضون يوم عمل واحد.",
      "sections": [
        {
          "heading": "المبيعات",
          "body": "هل ترغب في جولة تعريفية بخطط Pro أو Enterprise، أو مساعدة في نقل الأرقام والترحيل من HubSpot؟ أرسل بريدًا إلكترونيًا إلى sales@freecrm.com."
        },
        {
          "heading": "الدعم",
          "body": "هل أنت عميل حالي؟ افتح تذكرة من داخل التطبيق أو أرسل بريدًا إلكترونيًا إلى support@freecrm.com. عملاء Pro و Enterprise يحصلون على استجابة ذات أولوية."
        },
        {
          "heading": "الخصوصية والأمان",
          "body": "أسئلة الخصوصية: privacy@freecrm.com. إفصاحات الأمان: security@freecrm.com. نؤكد استلام التقارير في غضون 24 ساعة."
        },
        {
          "heading": "عنوان البريد",
          "body": "FreeCRM, Inc. — اتصالات العملاء — ديلاوير، الولايات المتحدة الأمريكية"
        }
      ]
    },
    "blog": {
      "title": "مدونة FreeCRM",
      "eyebrow": "المدونة",
      "description": "خطط عمل، تحليلات متعمقة للمنتجات، وقصص عملاء لفرق المبيعات الخارجية ومراكز الاتصال.",
      "intro": "خطط عمل عملية للمبيعات الخارجية، المبيعات الداخلية، وعمليات الاتصال للشركات الصغيرة والمتوسطة — كتبها الفريق الذي يبني FreeCRM.",
      "sections": [
        {
          "heading": "كيفية إعداد متصل فعال في 10 دقائق",
          "body": "دليل خطوة بخطوة لتوفير الأرقام، استيراد قائمة، وتشغيل أول جلسة اتصال فعال داخل FreeCRM."
        },
        {
          "heading": "5 طرق يتفوق بها FreeCRM على HubSpot في الاتصال",
          "body": "ميزة الاتصال والرسائل النصية القصيرة المدمجة، بدون تكلفة إضافية للدقيقة، مجانية دائمًا — ميزات الاتصال داخل FreeCRM مقارنة بـ Sales Hub من HubSpot."
        },
        {
          "heading": "من جداول البيانات إلى نظام CRM في فترة ما بعد الظهر",
          "body": "كيفية استيراد جهات الاتصال، وإعداد مسار عملك، وبدء تتبع الصفقات على FreeCRM في فترة ما بعد الظهيرة."
        },
        {
          "heading": "بناء مركز اتصال يضم 50 مقعدًا على FreeCRM",
          "body": "كيف قامت شركة خدمات منزلية بتطبيق FreeCRM لـ 50 وكيلًا في غضون أسبوعين — بما في ذلك توفير الأرقام المحلية وتسجيل المكالمات."
        }
      ]
    },
    "help": {
      "title": "مركز المساعدة",
      "eyebrow": "الموارد",
      "description": "أدلة، دروس تعليمية، وإجابات للحصول على أقصى استفادة من FreeCRM.",
      "intro": "ابحث في الأدلة والبرامج التعليمية، أو تصفح حسب الموضوع. يحصل عملاء Pro و Enterprise أيضًا على دعم بريد إلكتروني ذي أولوية.",
      "sections": [
        {
          "heading": "البدء",
          "body": "أنشئ حسابك، ادعُ فريقك، استورد جهات الاتصال، وقم بتكوين مسار عملك. معظم الفرق تبدأ العمل في أقل من ساعة."
        },
        {
          "heading": "المكالمات والرسائل النصية القصيرة",
          "body": "وفر الأرقام، وقم بإعداد ميزة النقر للاتصال، وسجل المكالمات، وقم بتشغيل المتصل القوي، وأرسل رسائل SMS مجانية من أي سجل جهة اتصال."
        },
        {
          "heading": "خطوط العمل والصفقات",
          "body": "خصص المراحل، أنشئ التقارير والتوقعات، وتتبع كل صفقة من عرض السعر إلى الفاتورة."
        },
        {
          "heading": "التكاملات",
          "body": "ربط Google، Microsoft 365، QuickBooks، Zapier، DocuSign، Zoom، Google Meet، Zoho Meeting، وأكثر من 6,000 تطبيق. مزامنة جهات الاتصال، التقويم، البريد الإلكتروني، الفواتير، والمزيد."
        },
        {
          "heading": "الإدارة والأمان",
          "body": "إدارة المستخدمين، الأدوار، تسجيل الدخول الموحد، سجلات التدقيق، وتصدير البيانات. يحصل عملاء Enterprise أيضًا على توفير SCIM ومدير نجاح عملاء مخصص."
        }
      ]
    },
    "apiDocs": {
      "title": "وثائق API لـ CRM",
      "eyebrow": "وثائق API",
      "description": "واجهة برمجة تطبيقات REST تستند إلى المعايير لالتقاط العملاء المحتملين، ومزامنة البيانات، وأتمتة المبيعات الداخلية والدعم داخل FreeCRM.",
      "intro": "احصل على أقصى استفادة من نظام CRM الخاص بك وأتمتة المبيعات الداخلية وخدمة العملاء. تدعم خدمات ويب API الخاصة بنا موقع الويب الخاص بك لدفع وسحب البيانات مباشرة إلى FreeCRM.",
      "whatHeading": "ما يمكنك فعله",
      "capturesHeading": "التقاط العملاء المحتملين للموقع الإلكتروني",
      "authHeading": "المصادقة",
      "webhooksHeading": "خوادم الويب",
      "rateLimitsHeading": "حدود المعدل و SDKs",
      "sections": [
        {
          "heading": "ما يمكنك فعله",
          "body": "ربط نماذج مواقع الويب، توجيه رسائل البريد الإلكتروني الواردة، فتح حالات الدعم، التقاط العملاء المحتملين، ومزامنة البيانات مع أي نظام خارجي. نستخدم واجهة برمجة تطبيقات REST قائمة على المعايير سهلة التكامل من أي تقنية."
        },
        {
          "heading": "التقاط العملاء المحتملين للموقع الإلكتروني",
          "body": "أضف قالب الكود الخاص بنا إلى أي نموذج ويب وابدأ في التقاط دعم العملاء وعملاء المبيعات المحتملين في الوقت الفعلي، مباشرة داخل FreeCRM. قلل من ضجيج البريد الإلكتروني الوارد ولا تفقد أي عميل محتمل."
        },
        {
          "heading": "خوادم الويب",
          "body": "اشترك في الأحداث — contact.created، deal.updated، call.completed، sms.received — وقم بدفعها إلى أنظمتك الخاصة في الوقت الفعلي."
        },
        {
          "heading": "حدود المعدل و SDKs",
          "body": "1,000 طلب/دقيقة على خطة Pro، 5,000/دقيقة على خطة Enterprise. تتوفر مكتبات تطوير البرمجيات (SDKs) الرسمية لـ Node و Python؛ وتغطي المكتبات المجتمعية Ruby و PHP و Go."
        }
      ]
    },
    "community": {
      "title": "مجتمع FreeCRM",
      "eyebrow": "المجتمع",
      "description": "تواصل مع الآلاف من مستخدمي FreeCRM، وشارك الخطط، واحصل على إجابات من الفريق.",
      "intro": "انضم إلى الآلاف من مستخدمي FreeCRM الذين يشاركون خطط العمل والأتمتة وأفضل الممارسات لعمليات المبيعات الخارجية ومركز الاتصال.",
      "sections": [
        {
          "heading": "المنتديات",
          "body": "اطرح الأسئلة، وشارك ما يعمل بشكل جيد، وتعلم من الفرق التي تدير FreeCRM بجميع الأحجام — من المؤسسين المنفردين إلى مراكز الاتصال التي تضم 50 مقعدًا."
        },
        {
          "heading": "Slack و Discord",
          "body": "قنوات في الوقت الفعلي للمستخدمين المتقدمين، والمسؤولين، والمطورين الذين يبنون على واجهة برمجة تطبيقات FreeCRM. يتواجد فريق المنتج هناك أيضًا."
        },
        {
          "heading": "ساعات العمل",
          "body": "جلسات أسبوعية مباشرة تغطي الإعداد، الاتصال الفعال، التكاملات، والميزات الجديدة. مجانية لجميع العملاء."
        }
      ]
    },
    "privacy": {
      "title": "سياسة الخصوصية",
      "eyebrow": "قانوني",
      "description": "سياسة خصوصية FreeCRM: بياناتك دائمًا خاصة ولا تتم مشاركتها أبدًا مع أطراف ثالثة.",
      "intro": "بياناتك خاصة 100%. لا نشارك بيانات العملاء مع أطراف ثالثة.",
      "sections": [
        {
          "heading": "جمع المعلومات واستخدامها",
          "body": "بياناتك خاصة بنسبة 100%. لا نستخدم البيانات التي تضعها في النظام لأي غرض بخلاف دعم نظام إدارة علاقات العملاء الخاص بك. تظل البيانات التي تقوم بإدخالها ملكية حصرية للأفراد والمنظمات التي أدخلتها. لا تتم مشاركة هذه البيانات أبدًا مع منظمات خارجية أو أطراف ثالثة. في حالة الاستحواذ، الإعسار، تغيير الملكية، أو أي تغيير في الهيكل المؤسسي، سنضمن دائمًا أن تظل بياناتك خاصة وغير معرضة للخطر."
        },
        {
          "heading": "ما نجمعها",
          "body": "نجمع معلومات التعريف الشخصية الضرورية لتوفير الخدمة: الاسم، البريد الإلكتروني، الهاتف، تفاصيل الفواتير، والبيانات التي تختار تخزينها داخل نظام إدارة علاقات العملاء الخاص بك. نجمع بيانات السجل والاستخدام لتشغيل الخدمة، تأمينها، وتحسينها."
        },
        {
          "heading": "كيف نستخدم المعلومات",
          "body": "نستخدم المعلومات لتوفير الخدمة وتحسينها، والتواصل معك، وتقديم الدعم، وتأمين المنصة، والامتثال للالتزامات القانونية. لا نبيع البيانات الشخصية أبدًا."
        },
        {
          "heading": "المشاركة",
          "body": "نحن لا نشارك أو نبيع معلومات المستخدمين. نحن نتعاقد مع معالجي بيانات موثوق بهم (مثل مزودي السحابة والاتصالات لدينا) لتقديم الخدمة فقط، بموجب عقود تتطلب السرية وحماية البيانات."
        },
        {
          "heading": "الخيارات والتصحيحات",
          "body": "يمكنك الوصول إلى بياناتك، وتصحيحها، وتصديرها، أو حذفها في أي وقت من داخل التطبيق، أو عن طريق الاتصال بـ privacy@freecrm.com."
        },
        {
          "heading": "الأمان",
          "body": "يعمل FreeCRM على Amazon AWS مع ضوابط أمان مادية وشبكة وتطبيقات متوافقة مع معايير الصناعة، وتشفير أثناء النقل وفي حالة السكون، ومراقبة على مدار الساعة طوال أيام الأسبوع."
        },
        {
          "heading": "الاتصال",
          "body": "أسئلة أو مخاوف؟ أرسل بريدًا إلكترونيًا إلى privacy@freecrm.com. سنرد في غضون فترة زمنية معقولة."
        }
      ]
    },
    "terms": {
      "title": "شروط الخدمة",
      "eyebrow": "قانوني",
      "description": "اتفاقية الاشتراك التي تحكم استخدامك لبرنامج وخدمات FreeCRM.",
      "intro": "باستخدام برنامج FreeCRM، فإنك توافق، نيابة عن الكيان المرخص للبرنامج، على الالتزام باتفاقية الاشتراك هذه.",
      "sections": [
        {
          "heading": "1. القبول",
          "body": "بالنقر على \"أوافق\" أو باستخدام برنامج FreeCRM الذي اخترته، فإنك توافق نيابة عن الكيان المرخص للبرنامج (\"الشركة\") بأن تصبح الشركة طرفًا في هذه الاتفاقية وأن لديك صلاحية إلزام الشركة. إذا لم توافق الشركة، فلا تقم بالتسجيل أو استخدام البرنامج."
        },
        {
          "heading": "2. وصف الخدمة",
          "body": "تقدم FreeCRM خدمتها وفقًا لشروط الخدمة هذه، والتي قد يتم تحديثها من قبلنا من وقت لآخر. يتم نشر النسخة الحالية دائمًا على هذا الرابط. قد تخضع الميزات المحددة لإرشادات إضافية منشورة، والتي يتم دمجها بالإشارة."
        },
        {
          "heading": "3. حسابك",
          "body": "أنت مسؤول عن الحفاظ على سرية بيانات الاعتماد الخاصة بك وعن جميع الأنشطة التي تتم تحت حسابك. أبلغنا فورًا بأي استخدام غير مصرح به."
        },
        {
          "heading": "4. الاستخدام المقبول",
          "body": "أنت توافق على عدم استخدام FreeCRM لإرسال رسائل بريد إلكتروني غير مرغوب فيها، أو مضايقة الآخرين، أو انتهاك الملكية الفكرية، أو توزيع البرامج الضارة، أو انتهاك أي قانون معمول به. قد نقوم بتعليق الحسابات التي تنتهك هذه القواعد."
        },
        {
          "heading": "5. الرسوم",
          "body": "تقدم الخطة المجانية بدون رسوم. يتم دفع فواتير خطتي Pro و Enterprise مقدمًا على أساس شهري أو سنوي. يتم دفع فواتير استخدام الاتصالات (الأرقام، الدقائق، الرسائل النصية القصيرة) وفقًا للأسعار المنشورة."
        },
        {
          "heading": "6. ملكية البيانات",
          "body": "تحتفظ بجميع الحقوق في البيانات التي تضعها في FreeCRM. نحن نعالجها فقط لتوفير الخدمة وتحسينها."
        },
        {
          "heading": "7. الإنهاء",
          "body": "يجوز لأي من الطرفين الإنهاء في أي وقت. عند الإنهاء، يمكنك تصدير بياناتك؛ وبعد فترة معقولة قد نقوم بحذفها."
        },
        {
          "heading": "8. إخلاء المسؤولية وتحديد المسؤولية",
          "body": "يتم تقديم الخدمة \"كما هي\" بدون ضمانات من أي نوع. إلى أقصى حد يسمح به القانون، تقتصر المسؤولية الإجمالية لـ FreeCRM على الرسوم المدفوعة خلال الاثني عشر شهرًا السابقة للمطالبة."
        },
        {
          "heading": "9. القانون الحاكم",
          "body": "تخضع هذه الاتفاقية لقوانين ولاية ديلاوير، الولايات المتحدة الأمريكية، بغض النظر عن مبادئ تنازع القوانين."
        }
      ]
    },
    "security": {
      "title": "الأمان",
      "eyebrow": "الثقة",
      "description": "كيف يحافظ FreeCRM على أمان بياناتك — مبني على Amazon AWS مع التشفير، المراقبة على مدار الساعة طوال أيام الأسبوع، وضوابط وصول صارمة.",
      "intro": "نحن نأخذ أمن البيانات على محمل الجد. يعمل FreeCRM على Amazon AWS بهدف تحقيق توفر ستة تسعات (99.9999%) ومهندسين في الخدمة 24/7/365.",
      "sections": [
        {
          "heading": "البنية التحتية",
          "body": "يعمل FreeCRM على Amazon AWS. تفي مرافقنا المادية أو تتجاوز جميع المتطلبات الفيدرالية والدولية لأمان البيانات، والنسخ الاحتياطي، واستئناف الأعمال، والاستمرارية."
        },
        {
          "heading": "التشفير",
          "body": "يتم تشفير جميع البيانات أثناء النقل باستخدام TLS 1.2+ وفي حالة التخزين باستخدام AES-256. يتم تشفير النسخ الاحتياطية وتخزينها عبر مناطق توفر متعددة."
        },
        {
          "heading": "ضوابط الوصول",
          "body": "وصول قائم على الأدوار داخل التطبيق، مبدأ أقل الامتيازات للوصول إلى الإنتاج، وتسجيل تدقيق للإجراءات الإدارية. يحصل عملاء Enterprise على SAML، وتوفير SCIM، وسجلات تدقيق كاملة."
        },
        {
          "heading": "المراقبة والاستجابة",
          "body": "مراقبة المنصة على مدار الساعة طوال أيام الأسبوع، تنبيهات تلقائية، وفريق هندسة تحت الطلب. نقوم باختبار النسخ الاحتياطية بانتظام ونجري تمارين استجابة للحوادث الدورية."
        },
        {
          "heading": "الإبلاغ عن نقطة ضعف",
          "body": "أرسل بريدًا إلكترونيًا إلى security@freecrm.com مع التفاصيل. نؤكد استلام التقارير في غضون 24 ساعة ونقدر الإفصاح المسؤول."
        }
      ]
    },
    "dpa": {
      "title": "ملحق معالجة البيانات",
      "eyebrow": "قانوني",
      "description": "يحكم DPA طريقة معالجة FreeCRM للبيانات الشخصية نيابة عن العملاء، بما يتوافق مع اللائحة العامة لحماية البيانات (GDPR) والقوانين المماثلة.",
      "intro": "يكمل ملحق معالجة البيانات هذا (DPA) اتفاقية الاشتراك الخاصة بك في FreeCRM ويحكم كيفية معالجتنا للبيانات الشخصية نيابة عنك.",
      "sections": [
        {
          "heading": "1. الأدوار",
          "body": "أنت (العميل) هو المتحكم بالبيانات. يعمل FreeCRM كمعالج بيانات ويعالج البيانات الشخصية فقط بناءً على تعليماتك الموثقة، بما في ذلك التحويلات، باستثناء ما هو مطلوب بموجب القانون المعمول به."
        },
        {
          "heading": "2. موضوع المدة",
          "body": "الموضوع: توفير خدمة FreeCRM. المدة: فترة الاتفاقية بالإضافة إلى أي فترة احتفاظ بعد الإنهاء."
        },
        {
          "heading": "3. المعالجون من الباطن",
          "body": "نحن نستخدم معالجين من الباطن مؤهلين (بما في ذلك AWS للاستضافة ومزودي الاتصالات لدينا لخدمات الصوت والرسائل النصية القصيرة). تتوفر قائمة محدثة عند الطلب. نُعلم العملاء بالتغييرات الجوهرية."
        },
        {
          "heading": "4. إجراءات الأمان",
          "body": "نحن نطبق تدابير تقنية وتنظيمية مناسبة للمخاطر، بما في ذلك التشفير أثناء النقل وفي حالة عدم الاستخدام، وضوابط الوصول، والتسجيل، وإدارة الثغرات الأمنية، وتدريب الموظفين."
        },
        {
          "heading": "5. حقوق أصحاب البيانات",
          "body": "نحن نساعدك في تلبية طلبات أصحاب البيانات (الوصول، التصحيح، الحذف، قابلية النقل) من خلال الأدوات داخل التطبيق، وعند الحاجة، من خلال الدعم."
        },
        {
          "heading": "6. التحويلات الدولية",
          "body": "عندما يتم نقل البيانات الشخصية خارج المنطقة الاقتصادية الأوروبية أو المملكة المتحدة أو سويسرا، فإن النقل يتم بموجب البنود التعاقدية القياسية أو آلية نقل قانونية أخرى."
        },
        {
          "heading": "7. إشعار الاختراق",
          "body": "سنقوم بإخطارك دون تأخير لا مبرر له بعد إدراكنا بحدوث اختراق للبيانات الشخصية يؤثر على بياناتك."
        },
        {
          "heading": "8. المراجعات",
          "body": "بناءً على إشعار معقول، سنقوم بتوفير المعلومات الضرورية لإثبات الامتثال، بما في ذلك تقارير التدقيق من طرف ثالث حيثما ينطبق ذلك."
        }
      ]
    },
    "industriesIndex": {
      "title": "FreeCRM حسب الصناعة",
      "eyebrow": "الصناعات",
      "description": "اطلع على كيفية استخدام الفرق في مراكز الاتصال، التأمين، العقارات، طب الأسنان، الخدمات الاحترافية، والمزيد لـ FreeCRM.",
      "intro": "قوالب وخطوط سير عمل للصناعات التي تعتمد على FreeCRM."
    }
  }
};

export default ar;
